export default "__VITE_ASSET__B0P5Ujgm__"